import {
  CustomButton,
  SearchBar,
  SwitchButton,
  searchDateFormat,
} from "components/form";
import React, { useEffect, useState } from "react";
import { IoArrowDownSharp } from "react-icons/io5";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { MdDelete } from "react-icons/md";
import { dateFormatWithTime } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt, FaEye } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { getLocalStorage, setLocalStorage } from "config/config";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { DatePicker, Input } from "common/InputForm";
import { toast } from "sonner";
import { userPlaceholder } from "assets/icons";
import {
  addCategoryApi,
  addOrUpdatCategory,
  categoryListApi,
  removeCategory,
  updateCategoryApi,
  updateStatus,
} from "services/category";
import { setJwtToken } from "config/axiosInstance";
import axios from "axios";
const ProductCategoryManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const categoryValue = searchParams.get("categoryValue") || "";

  const [loader, onShow, onHide] = useFullPageLoader();
  const [title, setTitle] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [image, setImage] = useState({});
  const [selectedId, setSelectedId] = useState("");

  const [categoryModel, setCategoryModel] = useState(false);
  const [buttonLoaderUpdate, setButtonLoaderUpdate] = useButtonLoader("Update");
  const [errors, setErrors] = useState({});

  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelectedCategory({ categoryId: id });
    setDeleteModal(true);
    searchParams.set("page", activePage);
    setSearchParams(searchParams);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await removeCategory(selectedCategory.categoryId);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        setDeleteModal(false);
        categoryListHandler();
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  // change student status
  const statusHandler = (categoryId, status) => {
    setSelectedCategory({
      ...selectedCategory,
      id: categoryId,
      status: status === "true" ? "false" : "true",
      action: "changeStatus",
    });
    setStatusModal(true);
    searchParams.set("page", activePage);
    setSearchParams(searchParams);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await updateStatus(selectedCategory);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        categoryListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("categoryValue");

    setSearch("");
    searchParams.delete("page");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelectedCategory({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", activePage);
    setSearchParams(searchParams);
  };
  const handleCategory = (event) => {
    const value = event.target.value;
    searchParams.set("categoryValue", value);
    searchParams.set("page", activePage);
    setSearchParams(searchParams);
  };
  // student list handler
  const categoryListHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction,
    status = statusValue,
    categoryType=categoryValue,
    type="product"
  ) => {
    try {
      onShow();
      const res = await categoryListApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        status,
        categoryType,
        type
      });
      if (res?.data?.status === 200) {
        setTotal(res.data.data?.total);
        setCategoryList(res.data?.data?.categories);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  // add and edit handler
  const editHandler = (id, title, num) => {
    setCategoryModel(true);
    setSelectedId(id);
    setTitle(title);
    setOrderNumber(num);
  };
  // validation
  const validation = () => {
    let status = true;
    const error = {};
    console.log(error, "err");
    if (!title) {
      error["title"] = "title required";
      status = false;
    }
    if (!orderNumber) {
      error["orderNumber"] = "Order Number required";
      status = false;
    }
    setErrors(error);
    return status;
  };
  // update category
  const updateCategory = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaderUpdate(true);
      try {
        const formData = new FormData();
        formData.append("id", selectedId);
        formData.append("name", title);
        formData.append("orderNumber", orderNumber);
        formData.append("type","product")
        const res = await updateCategoryApi(formData);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "updateCategory");
          categoryListHandler();
          setOrderNumber("");

          setCategoryModel(false);
          setTitle("");
          setErrors("");
        } else {
          toastMessage(res?.data?.message, "error", "updateCategory");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaderUpdate(false);
      }
    }
  };
  const addCategory = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoader(true);
      try {
        const formData = new FormData();
        formData.append("name", title);
        formData.append("orderNumber", orderNumber);
        formData.append("type","product")
        const res = await addCategoryApi(formData);
        console.log(res, "res");
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "updateGroup");
          categoryListHandler();
          setCategoryModel(false);
          setTitle("");

          setOrderNumber("");
          setImage({});
          setErrors("");
        } else {
          // toastMessage(res?.data?.message, "error", "updateGroup");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    categoryListHandler();
  }, [searchParams, debouncedValue, fieldName, direaction, statusValue,categoryValue]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);
  useEffect(() => {
    setLocalStorage("categoryList", "search", search);
  }, [search]);

  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>Product Category Management</h3>
            <div className="d-flex">
              <CustomButton
                type="button"
                className="button mx-2"
                onClick={() => setCategoryModel(true)}
              >
                Add Category
              </CustomButton>
            </div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />
              <select
                className="input form-control"
                value={statusValue}
                onChange={handleStatus}
              >
                <option value={""}>Select Status</option>
                <option value="true">Active</option>
                <option value="false">In Active</option>
              </select>

              <select
                className="input form-control"
                value={categoryValue}
                onChange={handleCategory}
              >
                <option value={""}>Select Category</option>
                <option value="Tops">Tops</option>
                <option value="Bottoms">Bottoms</option>
                <option value="Dresses">Dresses</option>
                <option value="Shoes">Shoes</option>
                <option value="Accessories">Accessories</option>
                <option value="Jewelry">Jewelry</option>
                <option value="Jumpsuits">Jumpsuits</option>

              </select>
              <CustomButton onClick={resetFilterHandler}>Reset </CustomButton>

            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap">S.No. </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("name")}
                    >
                      Category
                      <span className="shorting">
                        {fieldName === "name"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap"> Category Type</th>
                    <th className="nowrap">Sub Category</th>
                    <th
                      className="nowrap text-center cursor-pointer"
                      onClick={() => handleSort("orderNumber")}
                    >
                      Order number
                      <span className="shorting">
                        {fieldName === "orderNumber"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>

                    <th className="text-center">Status</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {categoryList && categoryList.length > 0 ? (
                    categoryList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          <td className="nowrap">{index + 1}</td>
                          <td className="nowrap">{data?.name}</td>
                          <td className="nowrap">{data?.categoryType}</td>
                          <td className="text-capitalize">
                            {data?.subcategories?.length
                              ? data.subcategories.join(", ")
                              : "---"}
                          </td>
                          <td className="text-center">{data?.orderNumber}</td>
                          <td className="text-center">
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                statusHandler(
                                  data._id,
                                  data?.status.toString()
                                );
                              }}
                            >
                              <SwitchButton status={data?.status.toString()} />
                            </Link>
                          </td>
                          <td>
                            {" "}
                            <div className="icon_wrap">
                              <Link
                                to={`sub-category/${data._id}`}
                                className="icon_button"
                              >
                                <FaEye />
                              </Link>
                              <Link
                                onClick={() =>
                                  editHandler(
                                    data?._id,
                                    data?.name,
                                    data?.orderNumber
                                  )
                                }
                                className="icon_button"
                              >
                                <FaRegEdit />
                              </Link>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Category data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete Student Modal */}
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelectedCategory({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Category?"
        title="Delete Category"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />

      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this Category?"
        title="Change Status"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />

      {/*edit Group */}
      <CustomModal
        className={"edit_model"}
        show={categoryModel}
        handleClose={() => {
          setCategoryModel(false);
          setTitle("");
          setErrors("");
          setSelectedId(null);
        }}
      >
        <h3>{selectedId ? "Edit Category" : "Add Category"}</h3>

        <div className="form_field">
          <Input
            className={"form-control input"}
            label={"Enter Title"}
            type={"text"}
            value={title || ""}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={"Enter title"}
            name={"title"}
            error={errors?.title}
          />
        </div>
        <div className="form_field">
          <Input
            className={"form-control input"}
            label={"Order Number"}
            type={"number"}
            value={orderNumber || ""}
            onChange={(e) => setOrderNumber(e.target.value)}
            placeholder={"Enter Order Number"}
            name={"orderNumber"}
            error={errors?.orderNumber}
          />
        </div>
        <div className="button_wrap">
          <button
            type="button"
            className="button light"
            onClick={() => {
              setCategoryModel(false);
              setTitle("");
              setErrors("");
              setSelectedId(null);
            }}
          >
            Cancel
          </button>
          {selectedId ? (
            <button
              type="button"
              ref={buttonLoaderUpdate}
              onClick={updateCategory}
              className="button"
            >
              Submit
            </button>
          ) : (
            <button
              type="button"
              ref={buttonLoader}
              onClick={addCategory}
              className="button"
            >
              Submit
            </button>
          )}
        </div>
      </CustomModal>
    </>
  );
};
export default ProductCategoryManagement;
